<script>
import { parseISO } from 'date-fns/fp'
import { isBefore, isAfter } from 'date-fns'
import filter from 'lodash/filter'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import List from '@challenges/components/list.vue'

const INVALID_TIME = '0000-00-00 00:00:00'

export default {
  components: {
    Layout,
    Tabs,
    Tab,
    List,
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    competitions() {
      return this.currentUser.competitions
    },
    upcoming() {
      const list = filter(this.competitions, (item) => {
        return (
          item.start !== INVALID_TIME &&
          isAfter(parseISO(item.start), Date.now())
        )
      })
      return list
    },
    active() {
      const list = filter(this.competitions, (item) => {
        return (
          item.start !== INVALID_TIME &&
          isBefore(parseISO(item.start), Date.now()) &&
          item.end !== INVALID_TIME &&
          isAfter(parseISO(item.end), Date.now())
        )
      })
      return list
    },
    completed() {
      const list = filter(this.competitions, (item) => {
        return (
          item.start !== INVALID_TIME &&
          isBefore(parseISO(item.end), Date.now())
        )
      })
      return list
    },
  },
  methods: {},
}
</script>

<template>
  <Layout>
    <div class="bg-white px-7.5 pt-4 text-xl flex justify-between">
      My Competitions
      <router-link
        class="button secondary-button text-left px-6 text-lg"
        :to="{ name: 'challengesAdd' }"
      >
        + Add new
      </router-link>
    </div>

    <div>
      <Tabs
        :classes="'bg-white flex justify-around border-none'"
        :parent-classes="'bg-white flex justify-center'"
        :tab-classes="
          'border-b-5 pb-5 text-xl mr-16 leading-loose cursor-pointer'
        "
      >
        <Tab title="<span>Upcoming</span>">
          <List :competitions="upcoming" />
        </Tab>
        <Tab title="<span>Active</span>">
          <List :competitions="active" />
        </Tab>
        <Tab title="<span>Completed</span>">
          <List :competitions="completed" />
        </Tab>
      </Tabs>
    </div>
  </Layout>
</template>
